<template>
    <div class="app-container">
      <BjRouteTabs :route-list="ORDER_ABNORMAL_FIVE_ROUTE_LIST" />
      <BjPage ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :radio="radio"
      :before-reset-search="beforeResetSearch"
      :tooltip-config="{ showAll: false, enterable: false }"
      :selection="selection"
      :default-sort="defaultSort"
      :row-style="rowStyleFun"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @sort-change="sortChange"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
      >
        <template v-slot:baseForm>
            <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-props="['channel', 'storeIdList']" multiple />
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.No')" prop="orderNo">
                <BjInput v-model="queryParams.orderNo" :placeholder="$t('InternalOrder.No')" @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.SKU')" prop="skuCode">
                <BjInput v-model="queryParams.skuCode" :placeholder="$t('InternalOrder.SKU')" @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <!-- totalOrderStatus： 1新订单、2异常、3处理中、4缺货、7等待取货 ORDER_INTERNAL_NO_STATUS_LIST-->
            <el-col :span="colSpan">
              <el-form-item :label="$t('orderNewPatch.Status')" prop="totalOrderStatus">
                <BjSelectLov v-model="statusList" :placeholder="$t('orderNewPatch.Status')" multiple :option-list="ORDER_INTERNAL_NO_STATUS_LIST" />
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item :label="$t('BusinessPurchaseOrder2.means')" prop="shippingMethod">
                <BjSelectLov v-model="queryParams.shippingMethod" :placeholder="$t('BusinessPurchaseOrder2.means')" :option-list="CSG_ORDER_SHIPPING_METHODS_LIST" />
              </el-form-item>
            </el-col>
            <el-col v-if="!$store.getters.cusId" :span="colSpan">
              <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
                <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item :label="$t('PreoccupationManagement.Three')">
                <BjDateRangePicker v-model="queryParamsTime_order" :placeholder="$t('PreoccupationManagement.Three')" />
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.JobID')" prop="logisticsNo">
                <BjInput v-model="queryParams.logisticsNo" :placeholder="$t('InternalOrder.JobID')" @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.CourierName')" prop="logisticsCompany">
                <BjSelectLov v-model="queryParams.logisticsCompany" multiple :placeholder="$t('InternalOrder.CourierName')" :option-list="CourierNameList" />
              </el-form-item>
            </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button v-if="$store.getters.cusId" type="danger" class="delete-btn" @click="onCreate">{{ $t('addText') }}</el-button>
            <el-button v-if="$store.getters.cusId" type="primary" class="main-btn" @click="onImport">{{ $t('orderNewPatch.Import') }}</el-button>
            <BjFrontendExport
              type="primary"
              class="main-btn"
              :label-list="labelList"
              :rows="selectedRows"
              file-name="Sales Order.csv"
            />
          </el-col>
        </template>
        <!-- 展示列表 -->
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <vxe-table-column v-if="col.prop === 'orderTime'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="orderTime" :title="$t('orderNewPatch.orderDate')" width="165px" sortable>
              <template slot-scope="scope">
                <span>{{ scope.row[col.prop] | timeFilters }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column v-else-if="col.prop === 'creationDate'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="creationDate" :title="$t('orderNewPatch.creationDate')" width="165px" sortable>
              <template slot-scope="scope">
                <span>{{ scope.row[col.prop] | timeFilters({ isSession: true, dateFormat: 'DD/MM/YYYY HH:mm' }) }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column v-else-if="col.prop === 'sapPushTime'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="sapPushTime" :title="$t('orderNewPatch.sapPushTime')" width="165px" sortable>
              <template slot-scope="scope">
                <span>{{ scope.row[col.prop] | timeFilters }}</span>
              </template>
            </vxe-table-column>
            <el-table-column v-else-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
                <template v-else-if="col.prop === 'outerOrderNo'">
                  <span>{{ scope.row.webReference }}</span>
                  <BjCopyIcon :copy="scope.row.webReference" />
                </template>
                <template v-else-if="col.prop === 'sapOrderNo'">
                  <span>{{ scope.row[col.prop] }}</span>
                  <BjCopyIcon :copy="scope.row[col.prop]" />
                </template>
                <template v-else-if="col.prop === 'logisticsNo'">
                  <span class="link" @click="openTrackingDetails(scope.row)">{{ scope.row[col.prop] }}</span>
                </template>
                <template v-else-if="col.prop === 'totalOrderStatus'">
                  <el-tag :type="scope.row[col.prop] === 1 ? 'success' : 'info'">{{
                    $t(ORDER_INTERNAL_NO_STATUS_LIST.bjGet(scope.row[col.prop]))
                  }}</el-tag>
                </template>
                <template v-else-if="col.prop === 'orderHandleStatus'">
                  {{ (scope.row.totalOrderStatus == 1 && scope.row.orderHandleStatus == -1) ? $t('ThreePartySalesOrder.OnHold'): $t(ORDER_WMS_STATUS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'shippingMethod'">
                  <el-tag>{{ $t(CSG_ORDER_SHIPPING_METHODS_LIST.bjGet(scope.row[col.prop])) }}</el-tag>
                </template>
                <template v-else-if="col.prop === 'isNeedQuota'">
                  <span>{{ scope.row.shippingMethod.toLowerCase().includes('csg manual') ? (scope.row.isNeedQuota?'Yes':' ') : ' ' }}</span>
                </template>
                <template v-else-if="col.prop === 'shippingWarehouse'">
                  {{ scope.row.circulationStatus == '1' ? scope.row[col.prop] : null }}
                </template>
                <template v-else-if="col.prop === 'quotedAmount'">
                  <span>{{ scope.row.shippingMethod.toLowerCase().includes('csg manual') ? scope.row.quotedAmount : ' ' }}</span>
                </template>
                <template v-else-if="col.prop === 'quotaOrNot'">
                  <el-tag v-if="scope.row.shippingMethod.toLowerCase().includes('csg manual')">{{ $t(ORDER_QUOTE_TYPES_STATUS.bjGet(scope.row[col.prop])) }}</el-tag>
                  <span v-else>{{' '}}</span>
                </template>
                <template v-else-if="col.prop === 'isProvideSize'">
                  <span>{{ scope.row.shippingMethod.toLowerCase().includes('customer manual')?(scope.row.isProvideSize?'Yes':' '):" " }}</span>
                </template>
                <template v-else-if="col.prop === 'isSizeWrite'">
                  <span>{{ scope.row.shippingMethod.toLowerCase().includes('customer manual')?(scope.row.repLength?'Yes':' '):" " }}</span>
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template #header>
                {{ $t('operationText') }}
                <el-tooltip placement="top">
                  <div slot="content">{{ $t('InternalOrder.ps1') }}</div>
                  <i class="el-icon-question" style="color: #082dc3;"></i>
                </el-tooltip>
              </template>
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <!-- orderHandleStatus 0-取消中 1-取消成功 2-取消失败 3-编辑中 4-编辑成功 5-编辑失败 -->
                <!-- totalOrderStatus 1新订单、2异常、3处理中、4缺货，5完成、6取消,7等待取货 ,8等待发货 -->
                <el-dropdown 
                  v-if="props.row.totalOrderStatus!=7" 
                  :disabled="props.row.totalOrderStatus==3 && ([0,2,3,5].includes(props.row.orderHandleStatus) || !props.row.innerOrderNo)" 
                  v-hasDropdownChildren @command="command($event, props.row)"
                  >
                  <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="![7,8].includes(props.row.totalOrderStatus) && ![0,3,6].includes(props.row.orderHandleStatus)" command="edit">{{ $t('editText') }} </el-dropdown-item>
                    <el-dropdown-item v-if="props.row.totalOrderStatus==1" command="push">{{ $t('ThreePartySalesOrder.push') }}</el-dropdown-item>
                    <el-dropdown-item v-if="props.row.totalOrderStatus==2" command="handleNormal">{{ $t('ThreePartySalesOrder.confirmation') }}</el-dropdown-item>
                    <el-dropdown-item v-if="[1,3].includes(props.row.totalOrderStatus)" command="urgent"> {{ $t('urgentText') }} </el-dropdown-item>
                    <el-dropdown-item v-if="!$store.getters.cusId && [3].includes(props.row.totalOrderStatus)&&props.row.sapOrderNo" command="package"> {{ $t('goodsPage.package.edit') }} </el-dropdown-item>
                    <!-- 暂停启动 v-permission:BusinessAbnormalOrder_openOrClose-->
                    <el-dropdown-item v-permission:BusinessAbnormalOrder_openOrClose v-if="props.row.totalOrderStatus==1 && props.row.orderHandleStatus == -1" command="Release">{{ $t('ThreePartySalesOrder.ReleaseHold') }}</el-dropdown-item>
                    <el-dropdown-item v-permission:BusinessAbnormalOrder_openOrClose v-if="props.row.totalOrderStatus==1 && props.row.orderHandleStatus != -1" command="Hold">{{ $t('ThreePartySalesOrder.HoldOrder') }}</el-dropdown-item>
                    <!--待发货==>> SCG -->
                    <el-dropdown-item v-if="props.row.shippingMethod&&props.row.shippingMethod.toLowerCase().includes('csg manual')&&props.row.totalOrderStatus==8&&!$store.getters.cusId" :disabled="props.row.isNeedQuota && props.row.quotaOrNot!=2" command="fillInLabel"> {{ $t('WarehouseManagement.form.Label') }} </el-dropdown-item>
                    <el-dropdown-item v-if="props.row.shippingMethod&&props.row.shippingMethod.toLowerCase().includes('csg manual')&&props.row.totalOrderStatus==8&&!$store.getters.cusId" :disabled="!props.row.isNeedQuota || props.row.quotaOrNot==2" command="fillInPrice"> {{ $t('WarehouseManagement.form.Quote') }} </el-dropdown-item>
                    <el-dropdown-item v-if="props.row.shippingMethod&&props.row.shippingMethod.toLowerCase().includes('csg manual')&&props.row.totalOrderStatus==8&&$store.getters.cusId" :disabled="!props.row.isNeedQuota || props.row.quotaOrNot!=1" command="ConfirmPrice"> {{ $t('WarehouseManagement.form.isQuotation') }} </el-dropdown-item>
                    <!--待发货==>> customer -->
                    <el-dropdown-item v-if="props.row.shippingMethod=='CUSTOMER MANUAL'&&props.row.totalOrderStatus==8" :disabled="props.row.isProvideSize && ![props.row.repLength,props.row.repWidth,props.row.repHeight,props.row.repWeight].every(e=>{return e > 0})" command="fillInLabel"> {{ $t('WarehouseManagement.form.Label') }} </el-dropdown-item>
                    <el-dropdown-item v-if="props.row.shippingMethod=='CUSTOMER MANUAL'&&props.row.totalOrderStatus==8&&!$store.getters.cusId" :disabled="!props.row.isProvideSize || ![props.row.repLength,props.row.repWidth,props.row.repHeight,props.row.repWeight].every(e=>{return e == null})" command="fillInSize"> {{ $t('WarehouseManagement.form.Dimension') }} </el-dropdown-item>
                    <!--待发货==>> SCG 、customer 共用 -->
                    <el-dropdown-item v-if="props.row.totalOrderStatus==8" command="ModifyTrans"> {{ $t('WarehouseManagement.form.Shipping') }} </el-dropdown-item>
                    <el-dropdown-item v-if="![0,3,6].includes(props.row.orderHandleStatus)" command="cancel"> {{ $t('cancelText') }} </el-dropdown-item>
                    <!-- 费用：应收、应付 tab页 -->
                    <el-dropdown-item v-if="showFeeButton" command="feeTab"> {{ $t('feeTab.fee') }} </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- 用户提货 -->
                <el-button v-if="!$store.getters.cusId && props.row.totalOrderStatus==7" type="text" class="delete-btn" @click="customerDelivery(props.row)">{{ $t('InternalSalesOrderDetails.customerDelivery') }}</el-button>
                <el-button v-if="(props.row.totalOrderStatus==7&&props.row.shippingMethod=='PICKUP') && ![0,3,6].includes(props.row.orderHandleStatus)" type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('cancelText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 导入弹窗 -->
      <ExcelImportDialog ref="ExcelImport" @submit="handleQuery" />
      <!-- 用户提货 -->
      <delveryDialog ref="delveryDialogRef" @reFresh="reFresh" />
      <!-- 报价弹框 -->
      <el-dialog :title="`${$t('editText')}${$t('goodsSku.detail.Price')} (AUD)`" :visible.sync="dialogFormVisible" width="400px" >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item prop="quotedAmount" :label="$t('goodsSku.detail.Price')+':'" >
            <BjInputMoney :disabled="form.isDisabled" v-model="form.quotedAmount" placeholder="AUD" style="width: 300px;" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="!form.isDisabled" @click="dialogFormVisible = false">{{ $t('cancelText') }}</el-button>
          <el-button v-if="!form.isDisabled" type="primary" @click="saveAmount()">{{ $t('saveText') }}</el-button>
          <el-button v-if="form.isDisabled" type="primary" @click="cancelAmount()">{{ $t('WarehouseManagement.form.refuse') }}</el-button>
          <el-button v-if="form.isDisabled" type="primary" @click="doneAmount()">{{ $t('WarehouseManagement.form.agree') }}</el-button>
        </div>
      </el-dialog>
      <!-- 运输方式弹框 -->
      <el-dialog :title="$t('WarehouseManagement.form.Shipping')" :visible.sync="dialogShippingVisible" width="400px">
        <el-form ref="Shippingform" :model="Shippingform" :rules="ShippingformRules">
          <el-form-item prop="shippingMethod" :label="$t('orderNewPatch.Shipping')+':'" >
            <BjSelectLov v-model="Shippingform.shippingMethod" :option-list="ShippingList"/>
          </el-form-item>
          <el-form-item prop="isNeedQuota" :label="$t('WarehouseManagement.form.Quotation')+':'" v-if="Shippingform.shippingMethod == 'CSG MANUAL'">
            <BjSelectLov v-model="Shippingform.isNeedQuota" :option-list="STATUS_YES_TRUE" />
          </el-form-item>
          <el-form-item prop="isProvideSize" :label="$t('WarehouseManagement.form.check')+':'" v-if="Shippingform.shippingMethod == 'CUSTOMER MANUAL'">
            <BjSelectLov v-model="Shippingform.isProvideSize" :option-list="STATUS_YES_TRUE" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogShippingVisible = false">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="updateShapping()">{{ $t('okText') }}</el-button>
        </div>
      </el-dialog>
      <!-- 尺寸弹框 -->
      <el-dialog :title="$t('WarehouseManagement.form.Dimension')" :visible.sync="dialogSizeVisible" width="400px">
        <el-form ref="SizeForm" :model="SizeForm" :rules="SizeFormRules">
          <el-form-item :label="$t('WarehouseManagement.form.Length')" prop="repLength">
            <BjInputMoney v-model="SizeForm.repLength">
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
          <el-form-item :label="$t('WarehouseManagement.form.Width')" prop="repWidth">
            <BjInputMoney v-model="SizeForm.repWidth">
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
          <el-form-item :label="$t('WarehouseManagement.form.Height')" prop="repHeight">
            <BjInputMoney v-model="SizeForm.repHeight">
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
          <el-form-item :label="$t('WarehouseManagement.form.Weight')" prop="repWeight">
            <BjInputMoney v-model="SizeForm.repWeight">
              <template slot="append">kg</template>
            </BjInputMoney>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogSizeVisible = false">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="updateSize()">{{ $t('okText') }}</el-button>
        </div>
      </el-dialog>
      <!-- 新增/编辑弹窗 -->
      <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />
      <!-- 物流单号查物流弹窗 -->
      <DeliverDialog ref="DeliverDialogRef"/>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { orderApi, thirdApi, logisticApi } from '@/api';
  import ExcelImportDialog from '../stock/ExcelImportDialog.vue';
  import delveryDialog from '../collectPending/delveryDialog';
  import DataForm from '../processing/DataForm.vue';
  import DeliverDialog from '../../internal/components/LogisticsTable/DeliverDialog.vue';
  import { ORDER_ABNORMAL_FIVE_ROUTE_LIST,
    ORDER_INTERNAL_NO_STATUS_LIST,
    ORDER_WMS_STATUS_LIST,
    CSG_ORDER_SHIPPING_METHODS_LIST,
    ORDER_QUOTE_TYPES_STATUS,
    STATUS_YES_TRUE
  } from '@/utils/constants';
  import { getShippingList } from '@/utils/index';
  import { timeFilters } from '@/filters';

  const sessionTimeOptions = { isSession: true, dateFormat: 'DD/MM/YYYY HH:mm' };
  const RECEIVABLE_PERMISSION = 'BusinessOrderFeeTabReceivable'.toLocaleLowerCase();
  const PAYABLE_PERMISSION = 'BusinessOrderFeeTabPayable'.toLocaleLowerCase();
  const URGENT_TAG_CODE = 'LB1718612626520-1753039007';

  export default {
    name: 'BusinessAbnormalOrderALL',
    components: {delveryDialog, ExcelImportDialog,DataForm,DeliverDialog},
    mixins: [pageMiXin],
    data() {
      return {
        selection: true,
        colSpan: 4,
        ORDER_ABNORMAL_FIVE_ROUTE_LIST,
        ORDER_INTERNAL_NO_STATUS_LIST,
        ORDER_WMS_STATUS_LIST,
        CSG_ORDER_SHIPPING_METHODS_LIST,
        ORDER_QUOTE_TYPES_STATUS,
        STATUS_YES_TRUE,
        queryApi: orderApi.getCSGThirdOrderPage,
        // 查询参数
        queryParamsTime_order: [],
        CourierNameList: [],
        queryParams: {
          orderNo: null,
          skuCode: null,
          orderStartTime: null,
          payEndTime: null,
          channel: null,
          storeIdList: [],
          totalOrderStatus: [1, 2, 3, 4, 7, 8],
          cusId: null,
          shippingMethod: null,
          sortParam: null,
          sortOrder: null,
          logisticsNo: null,
          logisticsCompany: [],
        },
        labelList1: [
          { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100', export: { roles: ['admin'], options: () => this.customerList } },
          { label: this.$t('InternalOrderListcompent.name'), prop: 'receiverName', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190', export: { prop: 'webReference' } },
          { label: this.$t('InternalOrder.form.wmsOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false, width: '165'},
          { label: this.$t('orderNewPatch.Status'), prop: 'totalOrderStatus', isCheck: true, disabled: false, width: '165', export: { options: ORDER_INTERNAL_NO_STATUS_LIST, translate: true } },
          { label: this.$t('orderNewPatch.wmsStatus'), prop: 'orderHandleStatus', isCheck: true, disabled: false, width: '165', export: { options: ORDER_WMS_STATUS_LIST, translate: true } },
          { label: this.$t('orderNewPatch.Detail'), prop: 'shippingWarehouse', isCheck: true, disabled: false, width: '185', export: false },
          { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '110'},
          { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '124'},
          { label: this.$t('orderNewPatch.Shipping'), prop: 'shippingMethod', isCheck: true, disabled: false, width: '200'},
          { label: this.$t('InternalOrder.form.document'), prop: 'logisticsNo', isCheck: true, disabled: false, width: '140' },
          { label: this.$t('orderNewPatch.orderDate'), prop: 'orderTime', isCheck: true, disabled: false, width: '140', export: { formatter: value => timeFilters(value) } },
          { label: this.$t('orderNewPatch.creationDate'), prop: 'creationDate', isCheck: true, disabled: false, width: '140', export: { formatter: value => timeFilters(value, sessionTimeOptions) } },
          { label: this.$t('orderNewPatch.sapPushTime'), prop: 'sapPushTime', isCheck: true, disabled: false, width: '140', export: { formatter: value => timeFilters(value) } },
          { label: this.$t('orderNewPatch.ShippingCost'), prop: 'totalPrice', isCheck: true, disabled: false },
          { label: this.$t('orderNewPatch.Courier'), prop: 'logisticsCompany', isCheck: true, disabled: false },
          { label: this.$t('WarehouseManagement.form.Quotation'), prop: 'isNeedQuota', isCheck: true, disabled: false, export: false },
          { label: this.$t('WarehouseManagement.form.amount'), prop: 'quotedAmount', isCheck: true, disabled: false, export: false },
          { label: this.$t('WarehouseManagement.form.quotationStatus'), prop: 'quotaOrNot', isCheck: true, disabled: false,width: '105', export: false },
          { label: this.$t('WarehouseManagement.form.check'), prop: 'isProvideSize', isCheck: true, disabled: false, export: false },
          { label: this.$t('WarehouseManagement.form.filled'), prop: 'isSizeWrite', isCheck: true, disabled: false, export: false },
          { label: this.$t('InternalSalesOrderDetails.Merchant'), prop: 'orderRemarks', isCheck: false, disabled: false, export: false },
          { label: this.$t('InternalSalesOrderDetails.Customer'), prop: 'serviceRemarks', isCheck: false, disabled: false, export: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '130' },
        ],
        statusList: [],
        defaultSort: [],
        dialogFormVisible: false,
        form: {
          innerOrderNo:null,
          totalOrderStatus:null,
          isDisabled: false,
        },
        rules:{
          quotedAmount: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        },

        dialogShippingVisible: false,
        Shippingform: {
          shippingMethod:'CUSTOMER MANUAL',
          isNeedQuota: null,
          isProvideSize: null,
        },
        ShippingList: [],

        dialogSizeVisible: false,
        SizeForm: {
          repLength:'0.00',
          repWidth:'0.00',
          repHeight:'0.00',
          repWeight:'0.00',
        },
        SizeFormRules:{
          repLength: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          repWidth: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          repHeight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          repWeight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        },
        ShippingformRules: {
          shippingMethod: { required: true, message: this.$t('chooseText'), trigger: 'change' },
          isNeedQuota: { required: true, message: this.$t('chooseText'), trigger: 'change' },
          isProvideSize: { required: true, message: this.$t('chooseText'), trigger: 'change' },
        }
      };
    },
    computed: {
      labelList() {
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
      },
      permissionBtns() {
        return this.$store.getters.userPermissionBtns || [];
      },
      showFeeButton() {
        return [RECEIVABLE_PERMISSION, PAYABLE_PERMISSION].some(permission => this.permissionBtns.includes(permission));
      },
    },
    watch: {
      queryParamsTime_order(v) {
        this.queryParams.orderStartTime = (v || [])[0];
        this.queryParams.orderEndTime = (v || [])[1];
      },
      statusList(val) {
        if (val.length > 0) {
          this.queryParams.totalOrderStatus = val;
        } else {
          this.queryParams.totalOrderStatus = [1, 2, 3, 4, 7, 8];
        }
      }
    },
    mounted() {
      this.getLogisticsDataList()
    },
    methods: {
      // 获取物流下拉数据
      getLogisticsDataList() {
        logisticApi.getLogisticsBusiness({
            currentPage: 0,
            page: 0,
            pagesize: 999,
            size: 999,
          }).then(res => {
          this.CourierNameList = res.content.map(item => {
            return {
              label: item.name,
              value: item.name
            };
          });
        });
      },
      // 根据物流单号获取弹框数据并打开弹窗
      openTrackingDetails(row){
        this.$refs.DeliverDialogRef.show(row)
      },
      // 标红超时订单
      rowStyleFun({ row, rowIndex }) {
        const styleJson = {};
        if(row.isRed){
          styleJson.color = 'red';
          return this.$store.getters.cusId ? {} : styleJson;
        }
      },
      _pauseOrResumeOrder(row, status){
        orderApi.pauseOrResumeOrder({
          outerOrderNo: row.outerOrderNo,
          status,
        }).then(()=>{
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          setTimeout(()=>{ this.reFresh() }, 300)
        })
      },
      command(text, row) {
        // totalOrderStatus： 1新订单、2异常、3处理中、4缺货
        switch (text) {
          // 新订单、异常订单、缺货订单、处理中订单
          case 'edit':
            if ([1, 2].includes(row.totalOrderStatus)) {
              this.toOuterOrder(row);
            }
            if (row.totalOrderStatus == 3) {
              orderApi.getOrderSapStatus({ innerOrderNo: encodeURIComponent(row.innerOrderNo) }).then(res => {
                if (res.failed === false) {
                  this.$router.push({
                    name: 'BusinessOrderInternalEditCSG',
                    query: { innerOrderNo: row.innerOrderNo,status:row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus },
                  });
                }
              });
            }
            if (row.totalOrderStatus == 4) {
              // 内部订单编辑页
              this.$router.push({
                name: 'BusinessOrderInternalEditCSG',
                query: { innerOrderNo: row.innerOrderNo },
              });
            }
            break;
          // 新订单
          case 'push':
            this.handleNormal(row);
            break;
          // 异常订单
          case 'handleNormal':
            this.handleNormal(row);
            break;
          // 处理中订单
          case 'package':
            this.onPackage(row)
            break;
          // 新订单、处理中订单
          case 'urgent':
            this.urgentOrder(row);
            break;
          case 'Release':
            this._pauseOrResumeOrder(row, 1)
            break;
          case 'Hold':
            this._pauseOrResumeOrder(row, 0)
            break;
          // 跳内部详情页，控制 物流单模块保存 按钮，
          case 'fillInLabel':
            this.$router.push({
              name: 'BusinessOrderInternalViewCSG',
              query: { id: '', code: row.innerOrderNo, status: row.totalOrderStatus, type: 'edit', orderHandleStatus: row.orderHandleStatus },
            });
            break;
          // 弹出框，写入价格并保存
          case 'fillInPrice':
            this.form.innerOrderNo = row.innerOrderNo;
            this.form.totalOrderStatus = row.totalOrderStatus;
            this.form.isDisabled = false;
            this.dialogFormVisible = true;
            break;
          // 弹出框，确认价格或否认价格
          case 'ConfirmPrice':
            this.form = row;
            this.form.isDisabled = true;
            this.dialogFormVisible = true;
            break;
          // 弹出框，修改运输方式
          case 'ModifyTrans':
            getShippingList(row.cusId).then(res=>{
              const array1 = res.filter(item=> !item.isDisable)
              const keyArray = this.$lodash.keyBy(array1, 'value');

              this.Shippingform = JSON.parse(JSON.stringify({
                ...this.Shippingform,
                innerOrderNo:row.innerOrderNo,
                shippingMethod:row.shippingMethod,
                takingDeliveryWay:row.takingDeliveryWay,
                totalOrderStatus:row.totalOrderStatus,
                // isNeedQuota: row.isNeedQuota,
                // isProvideSize: row.isProvideSize,
              }));
              if(row.shippingMethod == 'PICKUP'){
                this.Shippingform.shippingMethod = null
                this.ShippingList = this.$lodash.map([
                  { value: 'CUSTOMER MANUAL', label: 'CUSTOMER MANUAL' },
                  { value: 'CSG MANUAL', label: 'CSG MANUAL' },
                ],item=>({
                  ...keyArray[item.value] || {}
                }))
              }else if(row.shippingMethod == 'CSG MANUAL' || (row.shippingMethod && row.shippingMethod.toLowerCase().includes('csg manual'))){
                this.Shippingform.shippingMethod = null
                this.ShippingList = this.$lodash.map([
                  { value: 'CUSTOMER MANUAL', label: 'CUSTOMER MANUAL' },
                  { value: 'PICKUP', label: 'PICKUP' },
                ],item=>({
                  ...keyArray[item.value] || {}
                }))
              }else if(row.shippingMethod == 'CUSTOMER MANUAL' || (row.shippingMethod && row.shippingMethod.toLowerCase().includes('customer manual'))){
                this.Shippingform.shippingMethod = null
                this.ShippingList = this.$lodash.map([
                  { value: 'CSG MANUAL', label: 'CSG MANUAL' },
                  { value: 'PICKUP', label: 'PICKUP' },
                ],item=>({
                  ...keyArray[item.value] || {}
                }))
              }
              this.dialogShippingVisible = true;
            })
            break;
          // 弹出框，修改 长/宽/高/重
          case 'fillInSize':
            this.SizeForm = JSON.parse(JSON.stringify(row));
            this.dialogSizeVisible = true;
            break;
          // 新订单、异常订单、缺货订单、处理中订单
          case 'cancel':
            if (row.totalOrderStatus == 3) {
              orderApi.getOrderSapStatus({ innerOrderNo: encodeURIComponent(row.innerOrderNo) }).then(res => {
                if (res.failed === false) {
                  this.onDelete(row);
                }
              });
            }else{
              this.onDelete(row);
            }
            break;
          // 费用：应收、应付 tab页
          case 'feeTab':
            this.$router.push({
              name: 'BusinessOrderInternalCSGFEE',
              query: { outerOrderNo: row.outerOrderNo }
            });
            break;
        }
      },
      // 查看
      onView(row) {
        // 1新订单、2异常、3处理中、4缺货、7等待取货、8待发货
        if ([1, 2].includes(row.totalOrderStatus)) {
          this.toOuterOrder(row, 'view');
        }
        if(row.totalOrderStatus == 3 && !row.innerOrderNo){
          this.toOuterOrder(row, 'view');
        }else if(row.totalOrderStatus == 3 && row.innerOrderNo){
          if(row.orderHandleStatus == 3){
            // 内部订单编辑页
            this.$router.push({
              name: 'BusinessOrderInternalEditCSG',
              query: { innerOrderNo: encodeURIComponent(row.innerOrderNo), status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus, cusId: row.cusId },
            });
          }else{
            // 内部订单详情页
            this.$router.push({
              name: 'BusinessOrderInternalViewCSG',
              query: { id: '', code: encodeURIComponent(row.innerOrderNo), type: 'edit', status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus,},
            });
          }
        }
        if (!row.innerOrderNo) return;
        if ([4, 7].includes(row.totalOrderStatus)) {
          // 内部订单详情页
          this.$router.push({
            name: 'BusinessOrderInternalViewCSG',
            query: { id: '', code: encodeURIComponent(row.innerOrderNo), type: 'edit', status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus },
          });
        }
        if (row.totalOrderStatus==8) {
          if(row.shippingMethod=='CSG MANUAL'){
            if(!(row.isNeedQuota && row.quotaOrNot!=2)){
              // 内部订单详情页
              this.$router.push({
                name: 'BusinessOrderInternalViewCSG',
                query: { id: '', code: row.innerOrderNo, type: 'edit', status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus },
              });
            }else{
              // 内部订单详情页
              this.$router.push({
                name: 'BusinessOrderInternalViewCSG',
                query: { id: '', code: row.innerOrderNo, status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus },
              });
            }
          }
          if(row.shippingMethod=='CUSTOMER MANUAL'){
            if(!(row.isProvideSize && ![row.repLength,row.repWidth,row.repHeight,row.repWeight].every(e=>{return e > 0}))){
              // 内部订单详情页
              this.$router.push({
                name: 'BusinessOrderInternalViewCSG',
                query: { id: '', code: row.innerOrderNo, type: 'edit', status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus },
              });
            }else{
              // 内部订单详情页
              this.$router.push({
                name: 'BusinessOrderInternalViewCSG',
                query: { id: '', code: row.innerOrderNo, status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus },
              });
            }
          }
        }
      },
      /** 包材侧边栏 */
      onPackage(row) {
        this.$refs.DataForm.show(row);
      },
      normalizeTags(tags) {
        if (Array.isArray(tags)) {
          return tags.filter(Boolean);
        }
        if (typeof tags === 'string') {
          return tags.split(',').map(item => item.trim()).filter(Boolean);
        }
        return [];
      },
      // 加急
      urgentOrder(row) {
        // 新订单 ==> 就是外部订单备注里加文字
        if (row.totalOrderStatus == 1) {
          // 第一步走加急接口
          orderApi.urgentThirdOrder({ outerOrderNo: encodeURIComponent(row.outerOrderNo) }).then(res => {
            if (res.failed === false) {
              // 第二步走转正接口
              thirdApi.thirdOrderToNormal({ outerOrderNo: row.outerOrderNo }).then(res => {
                if (res.failed === false) {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                }
              });
            }
          });
        }
        // 处理中订单 ==> 就是内部订单详情页打标签接口
        if (row.totalOrderStatus == 3) {
          const orderId = '';
          const orderCode = row.innerOrderNo;
          // 判断是否可以加急
          orderApi.getOrderSapStatus({ innerOrderNo: encodeURIComponent(row.innerOrderNo) }).then(res => {
            if (res.failed === false) {
              orderApi.getInternalDetailByIdCode({ orderCode, orderId}).then(e => {
                const orderInfo = e.orderInfoVO || {};
                const tagsList = this.normalizeTags(orderInfo.tags);
                const tags = tagsList.includes(URGENT_TAG_CODE) ? tagsList : tagsList.concat(URGENT_TAG_CODE);
                orderApi.updateOrderBase({ orderId: orderInfo.id, tags: tags.join(',') }).then(res => {
                  if (!res.failed) {
                    this.msgSuccess(this.$t('toast.operationSuccessText'));
                  }
                });
              });
            }
          });
        }
      },
      // 用户提货
      customerDelivery(item) {
        if(item.shippingMethod.toLowerCase().includes("csg manual") && (!item.logisticsNo || item.logisticsNo == ' ')){
          return this.$message.warning(this.$t('InternalOrder.ps2'));
        }
        this.$refs.delveryDialogRef.dialogVisible = true;
        this.$refs.delveryDialogRef.selectedRows = [item.innerOrderNo];
        // 获取当前时间  
      const now = new Date();
      const startOfWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 1); 
        this.$refs.delveryDialogRef.pickerOptions = {
          disabledDate(time) {
             // 如果选择的时间小于本周一的时间，则禁用
            if(new Date(item.receiveTime).getTime() > startOfWeek.getTime()){
              return time.getTime() < new Date(item.receiveTime).getTime();
            }else{
              return time.getTime() < startOfWeek.getTime();
            }
          },
        }
      },
      // 正序倒序
      sortChange (column) {
        switch (column.property) {
          case 'orderTime':
            this.queryParams.sortParam = column.property;
            this.queryParams.sortOrder = column.order;
            break;
          case 'creationDate':
            this.queryParams.sortParam = column.property;
            this.queryParams.sortOrder = column.order;
            break;
          case 'sapPushTime':
            this.queryParams.sortParam = column.property;
            this.queryParams.sortOrder = column.order;
            break;
        }
        this.defaultSort = [{ field: column.field, order: column.order }];
        this.$refs.BjPage.fetchData();
      },
      /** 新增 */
      onCreate() {
        this.$router.push({
          name: 'BusinessAddThirdOrderCSGView',
        });
      },
      /** 导入 */
      onImport() {
        this.$refs.ExcelImport.show();
      },
      // 跳外部详情
      toOuterOrder(item, orderType) {
        if (orderType) {
          this.$router.push({
            name: 'BusinessThirdOrderCSGView',
            query: { id: '', code: item.outerOrderNo, status: item.totalOrderStatus, type: orderType },
          });
        } else {
          this.$router.push({
            name: 'BusinessThirdOrderCSGView',
            query: { id: '', code: item.outerOrderNo, status: item.totalOrderStatus },
          });
        }
      },
      // 异常单转正
      handleNormal(item) {
        this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
        .then(() => {
          // 如果是新订单1或异常订单2，调用外部订单异常转正接口
          if (item.totalOrderStatus == 1 || item.totalOrderStatus == 2) {
            thirdApi.thirdOrderToNormal({ outerOrderNo: item.outerOrderNo }).then(res => {
              if (res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 2000);
              }
            });
          } else {
            // 如果是缺货订单4，调用重新预占接口（后端提供新接口）unPreemptInternalOrder(马光浩)
            orderApi.unPreemptInternalOrder().then(res => {
              if (res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 2000);
              }
            });
          }
        })
        .catch(() => {});
      },
      // 保存报价 并 关闭编辑弹窗
      saveAmount() {
        this.$refs.form.validate(valid => {
          if (valid) {
            orderApi.waitingUpdatePrice({
              innerOrderNo:this.form.innerOrderNo,
              totalOrderStatus:this.form.totalOrderStatus,
              quotedAmount:this.form.quotedAmount,
            }).then(res => {
                if (res.failed === false) {
                  this.dialogFormVisible = false;
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.reFresh();
                }
              })
          }
        })
      },
      // 否认报价 并 关闭编辑弹窗
      cancelAmount() {
        this.$confirm(this.$t('WarehouseManagement.form.change'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
        .then(() => {
            orderApi.waitingConfirmPrice({
              innerOrderNo:this.form.innerOrderNo,
              quotaOrNot:3,
              quotedAmount:this.form.quotedAmount,
              totalOrderStatus:this.form.totalOrderStatus,
            }).then(res => {
            if (res.failed === false) {
              this.dialogFormVisible = false;
              this.form.isDisabled = false;
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }
          })
        })
      },
      // 确认报价 并 关闭编辑弹窗
      doneAmount() {
        orderApi.waitingConfirmPrice({
          innerOrderNo:this.form.innerOrderNo,
          quotaOrNot:2,
          quotedAmount:this.form.quotedAmount,
          totalOrderStatus:this.form.totalOrderStatus,
        }).then(res => {
        if (res.failed === false) {
          this.dialogFormVisible = false;
          this.form.isDisabled = false;
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
          }
        })
      },
      // 修改物流方式 并 关闭编辑弹窗
      updateShapping() {
        this.$refs.Shippingform.validate(valid => {
          if (valid) {
            orderApi.waitingUpdateShipping(this.Shippingform).then(res => {
                if (res.failed === false) {
                  this.dialogShippingVisible = false;
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.reFresh();
                }
              })
          }
        })
      },
      // 修改 长/宽/高/重 并 关闭编辑弹窗
      updateSize() {
        if([this.SizeForm.repLength,this.SizeForm.repWidth,this.SizeForm.repHeight,this.SizeForm.repWeight].some(e=>e==0)){return this.msgSuccess('尺寸不可以为0');}
        this.$refs.SizeForm.validate(valid => {
          if (valid) {
            orderApi.waitingUpdateSize({
              innerOrderNo:this.SizeForm.innerOrderNo,
              totalOrderStatus:this.SizeForm.totalOrderStatus,
              repLength:this.SizeForm.repLength,
              repWidth:this.SizeForm.repWidth,
              repHeight:this.SizeForm.repHeight,
              repWeight:this.SizeForm.repWeight,
            }).then(res => {
                if (res.failed === false) {
                  this.dialogSizeVisible = false;
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.reFresh();
                }
              })
          }
        })
      },
      // 删除
      onDelete(item) {
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
        .then(() => {
          // 如果是新订单1或异常订单2，调用外部订单删除接口
          if (item.totalOrderStatus == 1 || item.totalOrderStatus == 2) {
            thirdApi.cancelThirdPartyGoods([item.outerOrderNo]).then(res => {
              if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
              }
            });
          }else if(item.totalOrderStatus == 3 || (item.totalOrderStatus == 7&&item.shippingMethod=='PICKUP') || item.totalOrderStatus == 8){
            // 如果是处理中订单3，调用csg订单取消接口；
            orderApi.cancelInternalProccessingOrder({ innerOrderNo: item.innerOrderNo }).then(res => {
              if (res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
              }
            });
          } else {
            // 如果是缺货订单4，调用内部订单取消接口；
            orderApi.cancelInternalOrder({ innerOrderNo: item.innerOrderNo }).then(res => {
              if (res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
              }
            });
          }
        })
        .catch(() => {});
      },
      /** 重置按钮操作 */
      beforeResetSearch() {
        this.queryParamsTime_order = [];
        this.queryParams.storeIdList = null;
        this.queryParams.cusId = null;
        this.statusList = [];
        this.queryParams.totalOrderStatus = [1, 2, 3, 4, 7, 8];
        this.defaultSort = [];
        this.queryParams.sortParam = null;
        this.queryParams.sortOrder = null;
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
